module.exports = __webpack_public_path__ + "img/ojk.ea23d2b8.png";